"use client";

import React, { useMemo, useState } from "react";
import { Tree } from "antd";
import type { TreeDataNode, TreeProps } from "antd";
import { useBlog } from "./BlogContext";
import { loadFunc } from "../common";
import { useSearchParams } from 'next/navigation';

interface InputNode {
  name: string;
  children: InputNode[];
}

interface SearchTreeProps {
  tags: InputNode[];
}

function convertTagsArrayToTreeData(input: InputNode[]): TreeDataNode[] {
  return input.map((node) => {
    const treeNode: TreeDataNode = {
      title: node.name,
      key: node.name,
    };

    if (node.children && node.children.length > 0) {
      treeNode.children = convertTagsArrayToTreeData(node.children);
    }

    return treeNode;
  });
}

const SearchTree: React.FC<SearchTreeProps> = ({ tags }) => {
  const searchParams = useSearchParams();
  const defaultTag: string[] = [searchParams.get('tag') || 'Career'];
  
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  const treeData = useMemo(() => convertTagsArrayToTreeData(tags), [tags]);

  const {
    setHasNext,
    setNextUrl,
    setBlogPosts,
    setCheckedTags,
    setCount,
    search,
  } = useBlog();

  const onExpand = (newExpandedKeys: any) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  };

  const onCheck: TreeProps["onCheck"] = (checkedKeys: any, info: any) => {
    setCheckedTags(checkedKeys);
    setHasNext(true);
    setBlogPosts([]);
    setNextUrl("");
    
    loadFunc(
      true,
      undefined,
      search,
      checkedKeys,
      [],
      setBlogPosts,
      setHasNext,
      setNextUrl,
      setCount,
    );
  };

  return (
    <div className="flex flex-col border max-h-[500px] overflow-auto md:overscroll-none border-slate-300 rounded-md p-4 gap-4">
      <p className="text-base	font-semibold">
        Categories
        <span className="text-sm font-light">
          (explore our range of careers, by expanding the categories below)
        </span>
      </p>
      <Tree
        checkable
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        defaultCheckedKeys={defaultTag}
        onCheck={onCheck}
        treeData={treeData}
        className="text-lg"
      />
    </div>
  );
};

export default SearchTree;
